import axios from 'axios';
import type { Pesquisa } from '@eleg360/types';

export interface EvolucaoPesquisa {
  id: string;
  instituto: string;
  periodo: string;
  created_at: string;
  resultados: Record<string, number>;
}

const API_URL = import.meta.env.VITE_API_URL || '/api';

export const pesquisasApi = {
  create: async (
    data: {
      instituto: string;
      periodo: string;
      metodologia: string;
      amostra: number;
      abrangencia: string;
      cenario: string;
      registro_tse?: string;
      confianca: 'alta' | 'media' | 'baixa';
      fonte_url?: string;
      resultados: Record<string, number>;
    },
    token: string,
  ) => {
    const res = await axios.post<Pesquisa>(`${API_URL}/eleg/pesquisas`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  list: async (token: string) => {
    const res = await axios.get<Pesquisa[]>(`${API_URL}/eleg/pesquisas`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  get: async (id: string, token: string) => {
    const res = await axios.get<Pesquisa>(`${API_URL}/eleg/pesquisas/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  getEvolucao: async (token: string) => {
    const res = await axios.get<EvolucaoPesquisa[]>(`${API_URL}/eleg/pesquisas/evolucao`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  update: async (id: string, data: Partial<Pesquisa>, token: string) => {
    const res = await axios.put<Pesquisa>(`${API_URL}/eleg/pesquisas/${id}`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  delete: async (id: string, token: string) => {
    await axios.delete(`${API_URL}/eleg/pesquisas/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
};
